import { FC } from 'react';
import styles from './login.module.scss';
import { Row, Col, Image } from 'antd';
import { LoginLayoutInterface } from './types';

// Login layout component
export const LoginLayout: FC<LoginLayoutInterface> = (props) => {
	const { children } = props;
	return (
		<div className={styles['login']}>
			<Row
				className={styles['login__wrapper']}
				justify="end"
				align={'middle'}
			>
				<Col span={11} xs={24}
					sm={20}
					md={16}
					lg={13}
					xl={13}
 /> 
				<Col className={styles['login__details']} span={13} xs={24}
					sm={20}
					md={16}
					lg={12}
					xl={8}
>
					<div className={styles['login__details--logo']}>
						<Image
							src={`/assets/images/pay2power-logo.png`}
							crossOrigin={
								process.env.REACT_APP_ENV === 'local'
									? undefined
									: 'anonymous'
							}
							width={230}
							// height={70}
							preview={false}
							alt="group"
						/>
					</div>
					<div className={styles['login__details--body']}>
						{children}
					</div>
				</Col>
			</Row>
		</div>
	);
};
